module.exports = __webpack_public_path__ + "img/gmtcbj.58ad4db0.jpg";